__webpack_require__.p = "https://prod.mena.safer.whs.amazon.dev/";